/* eslint-disable import/prefer-default-export */
export const COOKIES = ['__zlcprivacy', '__zlcmid'];
